export default function Benefits() {
  const benefits = [
    {
      icon: 'ri-emotion-happy-line',
      title: '自信に満ちた笑顔で毎日が輝く',
      description: '歯並びを気にせず、心から笑えるように。人前でも堂々と話せる自分に変わります。',
      color: 'from-pink-500 to-rose-500',
      image: 'https://public.readdy.ai/ai/img_res/bea3f5fd885ea619fa2918a54a656bcc.jpg'
    },
    {
      icon: 'ri-eye-off-line',
      title: '周囲に気づかれず、自然に美しく',
      description: '透明なマウスピースだから、職場でも友人との集まりでも誰にも気づかれません。「矯正してる」と言われる心配もゼロ。',
      color: 'from-teal-500 to-cyan-500',
      image: 'https://readdy.ai/api/search-image?query=A%20professional%20Japanese%20woman%20in%20her%2030s%20smiling%20naturally%20in%20an%20office%20or%20cafe%20setting%20wearing%20invisible%20clear%20aligners%20that%20are%20barely%20visible%2C%20bright%20natural%20lighting%2C%20modern%20clean%20background%20in%20soft%20teal%20tones%2C%20natural%20and%20discreet%20appearance%2C%20lifestyle%20photography%20showing%20confidence%20in%20social%20settings&width=800&height=600&seq=benefit-2&orientation=landscape'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: '健康的な口元で、若々しい印象に',
      description: '正しい歯並びは見た目だけでなく、噛み合わせや顔のバランスも改善。5歳若く見えると言われることも。',
      color: 'from-purple-500 to-indigo-500',
      image: 'https://readdy.ai/api/search-image?query=A%20youthful%20Japanese%20woman%20in%20her%2040s%20with%20a%20healthy%20beautiful%20smile%20showing%20perfect%20teeth%20alignment%2C%20soft%20professional%20lighting%2C%20clean%20elegant%20background%20in%20soft%20purple%20and%20white%20tones%2C%20showing%20vitality%20and%20health%2C%20professional%20beauty%20photography%2C%20radiant%20and%20rejuvenated%20appearance&width=800&height=600&seq=benefit-3&orientation=landscape'
    }
  ];

  return (
    <section id="benefits" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            マウスピース矯正で得られる<br />
            <span className="text-teal-600">3つの変化</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            理想の笑顔を手に入れることで、あなたの人生が変わります
          </p>
        </div>

        <div className="space-y-12">
          {benefits.map((benefit, index) => (
            <div key={index} className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-8 items-center`}>
              <div className="lg:w-1/2">
                <div className="relative rounded-2xl overflow-hidden shadow-2xl group">
                  <img 
                    src={benefit.image} 
                    alt={benefit.title} 
                    className="w-full h-96 object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className={`absolute inset-0 bg-gradient-to-br ${benefit.color} opacity-10`}></div>
                </div>
              </div>
              
              <div className="lg:w-1/2 space-y-6">
                <div className={`inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br ${benefit.color} shadow-lg`}>
                  <i className={`${benefit.icon} text-3xl text-white`}></i>
                </div>
                
                <div className="flex items-center gap-4">
                  <span className={`text-6xl font-bold bg-gradient-to-br ${benefit.color} bg-clip-text text-transparent`}>
                    0{index + 1}
                  </span>
                  <h3 className="text-3xl font-bold text-gray-900 leading-tight">{benefit.title}</h3>
                </div>
                
                <p className="text-lg text-gray-600 leading-relaxed pl-20">
                  {benefit.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-20 bg-gradient-to-br from-teal-50 to-blue-50 rounded-2xl p-8 md:p-12">
          <div className="flex flex-col md:flex-row items-center gap-8">
            <div className="md:w-2/3">
              <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
                あなたの笑顔が、未来を変える
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed">
                マウスピース矯正は、見た目の美しさだけでなく、あなたの自信と人生の質を向上させます。多くの患者様が「もっと早く始めればよかった」とおっしゃっています。
              </p>
            </div>
            <div className="md:w-1/3 flex justify-center">
              <div className="bg-white rounded-full p-8 shadow-lg">
                <div className="text-center">
                  <div className="text-5xl font-bold text-teal-600 mb-2">96%</div>
                  <div className="text-sm text-gray-600">患者満足度</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}